<template>
  <div class="RwvContentPdf">
    <div id="adobe-dc-view" class="pdf-view"></div>
  </div>
</template>

<script>
export default {
  name: "RwvContentPdf",
  props: {
    data: {
      type: Object,
      required: true
    }
  },
  mounted() {
    console.log("Adobe ")
    var adobeDCView = new AdobeDC.View({clientId: "afbbd2fd529c47509c9043e0b2065d6b", divId: "adobe-dc-view"});
    adobeDCView.previewFile({
      content:{location: {url: this.data.pdfLink}},
        metaData:{fileName: this.data.title + ".pdf"}
    }, {embedMode: "SIZED_CONTAINER", showDownloadPDF: false, showPrintPDF: false});
  }
};
</script>

<style lang="scss">
.pdf-view {
  max-height: 600px;
  min-height: 300px;
  height: 80vh;
  padding: 24px;
}
</style>
